import * as Actions from '../Actions/GerenciadorProcessoActions';
// import _ from '@lodash';

const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null
};

const GerenciadorProcessoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GERENCIADOR_PROCESSO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.GERENCIADOR_PROCESSO_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        case Actions.GERENCIADOR_PROCESSO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default GerenciadorProcessoReducer;
